import keymirror from 'keymirror';
import { request } from 'js/api/axios';
import { spreadApiKeys, extractApiKeys } from '../utils';
import { callApi } from '../api';

export const types = keymirror({
  ...spreadApiKeys('LIST_BREAKOUTS'),
  ...spreadApiKeys('CREATE_BREAKOUT'),
  ...spreadApiKeys('UPDATE_BREAKOUT'),
  ...spreadApiKeys('DELETE_BREAKOUT'),
});

const auth = (token) => ({ Authorization: `Bearer ${token}` });

export function listBreakouts(assessmentKey, assessmentKeys = null) {
  return (dispatch) =>
    callApi(
      {
        types: extractApiKeys(types.LIST_BREAKOUTS, types),
        request: (_data, token, currentWorkspaceId) =>
          request.get(`/api/workspaces/${currentWorkspaceId}/breakouts`, {
            params: assessmentKeys
              ? { assessment_keys: assessmentKeys }
              : { assessment_key: assessmentKey },
            headers: auth(token),
          }),
      },
      dispatch
    );
}

export function createBreakout(attrs) {
  return (dispatch) =>
    callApi(
      {
        types: extractApiKeys(types.CREATE_BREAKOUT, types),
        request: (data, token, currentWorkspaceId) =>
          request.post(
            `/api/workspaces/${currentWorkspaceId}/breakouts`,
            data,
            {
              headers: auth(token),
            }
          ),
        data: { breakout: attrs },
      },
      dispatch
    );
}

export function updateBreakout(id, attrs) {
  return (dispatch) =>
    callApi(
      {
        types: extractApiKeys(types.UPDATE_BREAKOUT, types),
        request: (data, token, currentWorkspaceId) =>
          request.patch(
            `/api/workspaces/${currentWorkspaceId}/breakouts/${id}`,
            data,
            { headers: auth(token) }
          ),
        data: { breakout: attrs },
      },
      dispatch
    );
}

export function deleteBreakout(id) {
  return (dispatch) =>
    callApi(
      {
        types: extractApiKeys(types.DELETE_BREAKOUT, types),
        request: (_data, token, currentWorkspaceId) =>
          request.delete(
            `/api/workspaces/${currentWorkspaceId}/breakouts/${id}`,
            { headers: auth(token) }
          ),
      },
      dispatch
    );
}
